import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  return _objectSpread({
    width: node.childNodes[0].style.width,
    color: node.childNodes[0].style.borderColor,
    thickness: node.childNodes[0].style.borderWidth
  }, getAdvanced(node));
});